import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { createListButtonStyles } from "@dana/Overrides/Widgets/MyLists/MyListsCreateListButton";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

createListButtonStyles.createListButton = mergeToNew(createListButtonStyles.createListButton, {
    color: themeColors.primary.danaBlue,
});

createListButtonStyles.overflowMenu = mergeToNew(createListButtonStyles.overflowMenu, {
    buttonProps: {
        css: css`
            background: transparent;
        `,
    },
    cssOverrides: {
        menuItem: css`
            &:hover {
                background: ${themeColors.primary.danaBlue};
                color: ${themeColors.primary.white};
            }
        `,
    },
});
